<template>
    <v-container>
        <v-dialog
                v-model="lockDialog"
                persistent
                width="500"
        >
            <v-card class="elevation-0">
                <v-toolbar class="mb-0" dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3">
                    <h2>{{$t('pagina_caduca')}}</h2>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-layout v-if="infoInvitation !== null" class="text-center" align-center justify-center fill-height>
            <v-flex xs12 sm7 md6 lg5 xl3>
                <h2>
                    <strong>
                        <span>{{$t('msg_qr_invitation1')}}</span>
                    </strong>
                </h2>
                <p>
                    <span style="background-color: #2b2301; color: #fff; display: inline-block; padding: 3px 10px; font-weight: bold; border-radius: 5px;">{{ infoInvitation.school.name }}</span>
                    <br>
                    <img
                            :src="infoInvitation.school.logo"
                            width="150px"
                    >
                </p>
                <p>{{$t('msg_qr_invitation2')}}</p>
                <v-flex xs12 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                    <v-layout v-for="(student, index) in infoInvitation.students" v-bind:key="index" align-center justify-center row wrap>
                        <v-spacer></v-spacer>
                        <v-flex  class="text-xs-center" xs12 sm6>
                            <div class="wrapperw">
                                <v-img
                                        :src="student.avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </div>
                        </v-flex>
                        <v-flex  class="text-xs-center" xs12 sm6>
                            <h3>{{student.name}}</h3>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <p><strong>{{$t('fecha_hora')}}: <br>{{ infoInvitation.date }}  {{infoInvitation.time}}</strong></p>
                <p v-if="infoInvitation.typeInv === 1"><strong>{{$t('fecha_expiracion')}}: <br>{{infoInvitation.expiration}}</strong></p>
                <p v-if="infoInvitation.typeInv === 1">
                  <strong>{{$t('dias_validos')}}:<br></strong>
                  <ul style="list-style: none; text-align: center;">
                    <li v-if="infoInvitation.diary.includes('0') === true">{{$t('Lunes')}}</li>
                    <li v-if="infoInvitation.diary.includes('1') === true">{{$t('Martes')}}</li>
                    <li v-if="infoInvitation.diary.includes('2') === true">{{$t('Miercoles')}}</li>
                    <li v-if="infoInvitation.diary.includes('3') === true">{{$t('Jueves')}}</li>
                    <li v-if="infoInvitation.diary.includes('4') === true">{{$t('Viernes')}}</li>
                    <li v-if="infoInvitation.diary.includes('5') === true">{{$t('Sabado')}}</li>
                    <li v-if="infoInvitation.diary.includes('6') === true">{{$t('Domingo')}}</li>
                  </ul>
                </p>
                <p><strong color="error">{{$t('Notas')}}: </strong>{{infoInvitation.notes}}</p>
                <p>{{$t('msg_qr_invitation3')}}</p>
                <v-card>
                    <v-toolbar class="mb-auto" dark color="primary">
                        <v-toolbar-title style="text-align: center;">
                            {{$t('qr_code')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="mt-4">
                        <v-row>
                            <v-flex xs12>
                                <v-img
                                        class="centrado"
                                        :src="url"
                                        width="200"
                                        height="200"
                                >
                                </v-img>
                                <p>
                                    <strong><span style="color: #000000;">{{ codigo_qr }}</span></strong>
                                </p>
                                <!--                                    <div v-if="infoInvitation[0].secEqu.length > 0">-->
                                <!--                                        <h4 style="text-align: center;">Equipo de Seguridad Necesario:</h4>-->
                                <!--                                        <ul style="text-align: center" v-for="item in infoInvitation[0].secEqu">-->
                                <!--                                            <li style="list-style:none;"><strong>{{item.nameEquipment}}</strong></li>-->
                                <!--                                        </ul>-->
                                <!--                                    </div>-->
                                <!--                                    <div v-else>-->
                                <!--                                        <h4 style="text-align: center;"><strong>Equipo de seguridad No Requerido</strong></h4>-->
                                <!--                                    </div>-->
                                <!--                                    <div style="text-align: center;">-->
                                <!--                                        <v-btn-->
                                <!--                                                class="white&#45;&#45;text"-->
                                <!--                                                :href="url_confirmar"-->
                                <!--                                                color="primary"-->
                                <!--                                        >-->
                                <!--                                            <v-icon left dark>mdi-check</v-icon>Confirmar Asistencia-->
                                <!--                                        </v-btn>-->
                                <!--                                    </div>-->
                                <!--                                    <div style="text-align: center;">-->
                                <!--                                        <a :href="urlWallet">-->
                                <!--                                            <v-img-->
                                <!--                                                    class="centrado"-->
                                <!--                                                    border="0"-->
                                <!--                                                    :src="require('../../assets/wallet.png')"-->
                                <!--                                                    width="150"-->
                                <!--                                                    contain>-->
                                <!--                                            </v-img>-->
                                <!--                                        </a>-->
                                <!--                                    </div>-->
                                <br>
                                <div>
                                    <v-icon>mdi-map-marker</v-icon>
                                    <a :href="infoInvitation.school.url_map">{{$t('msg_qr_invitation4')}}</a>
                                </div>
                            </v-flex>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'

export default {
  name: 'qr',
  data () {
    return {
      url: 'https://api.qrserver.com/v1/create-qr-code/?data=' + this.$route.params['qrcode'] + '&ecc=M&margin=20&size=400x400',
      codigo_qr: this.$route.params['qrcode'],
      url_confirmar: 'https://restest.intrare.app/Invitation/ConfirmedFromMail/' + this.$route.params['qrcode'] + '/True' + '/',
      urlWallet: 'https://restest.intrare.app/wallet/create/' + this.$route.params['qrcode'],
      infoInvitation: null,
      lockDialog: false
    }
  },
  created: async function () {
    await this.getInfoInvitation()
  },
  methods: {
    getInfoInvitation () {
      HTTP.get('invitation/no_permission/' + this.$route.params['qrcode'], {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language
        }
      })
      .then(result => {
        this.infoInvitation = result.data
        console.log(this.infoInvitation)
      })
      .catch(error => {
        if(error.request.status === 404) {
          this.lockDialog = true
        }
      })
    }
  }
}
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
    .wrapperw{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapperw img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
